import 'core-js/modules/es.symbol';
import 'core-js/modules/es.symbol.description';
import 'core-js/modules/es.symbol.to-primitive';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.date.to-primitive';
import 'core-js/modules/es.function.name';
import 'core-js/modules/es.number.constructor';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.to-string';
import React, { Component } from 'react';
import { assert, assertType } from 'yaassertion';
import { MessageFormat } from '@paypalcorp/worldready-message';
import { WorldReady, isWorldReadyInstance } from '@paypalcorp/worldready-core';
import hoistNonReactStatic from 'hoist-non-react-statics';

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

var _excluded = ["children", "worldReady", "id", "namespace", "source"],
  _excluded2 = ["children", "id", "namespace", "variables", "source"];
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
var Context = React.createContext();
var ContextProvider = function ContextProvider(_ref) {
  var locale = _ref.locale,
    children = _ref.children;
  var worldReady = new WorldReady(locale);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: worldReady
  }, children);
};
var ContextConsumer = Context.Consumer;
var DOCUMENTATION_HOMEPAGE = "https://github.paypal.com/pages/Globalization-R/worldready-js/docs";
var _MessageParts = function MessageParts(_ref2) {
  var messageParts = _ref2.messageParts;
  return /*#__PURE__*/React.createElement(React.Fragment, null, messageParts.map(function (_ref3, i) {
    var type = _ref3.type,
      value = _ref3.value,
      children = _ref3.children,
      variableName = _ref3.variableName;
    if (type === "variable-block") {
      var ret = value(/*#__PURE__*/React.createElement(_MessageParts, {
        messageParts: children
      }));
      if (process.env.NODE_ENV !== "production") {
        assert(React.isValidElement(ret), "Variable {{variableName}} should return a react element, not {{ret}}", {
          variableName: variableName,
          ret: ret
        });
      }
      return React.cloneElement(ret, Object.assign({
        key: i
      }, value.props));
    }
    if (React.isValidElement(value)) {
      return React.cloneElement(value, Object.assign({
        key: i
      }, value.props));
    }
    return value;
  }));
};
var MessageReactWrapper = function MessageReactWrapper(_ref4) {
  var children = _ref4.children,
    worldReady = _ref4.worldReady,
    id = _ref4.id,
    namespace = _ref4.namespace,
    source = _ref4.source,
    variables = _objectWithoutPropertiesLoose(_ref4, _excluded);
  if (process.env.NODE_ENV !== "production") {
    // 1: There are cases where empty elements are coming as empty array []
    // children, so need to check for length as well. At present we did not
    // identify the cause, it could be related to react version or due to preact.
    // Not able to reproduce this in unit tests ¯\_(ツ)_/¯
    assert(!children || !children.length /* 1 */, "Message must be an empty element (no children)");
    assertType(id, "id", ["array", "string"]);
    if (namespace) {
      assertType(namespace, "namespace", ["array", "string"]);
    }
    assert(isWorldReadyInstance(worldReady), "Missing worldReady object. Please read " + DOCUMENTATION_HOMEPAGE + "/about-get-started.html#reactjs");
  }
  var messageFormatter = new MessageFormat(worldReady, {
    id: id,
    source: source,
    namespace: namespace
  });
  return /*#__PURE__*/React.createElement(_MessageParts, {
    messageParts: messageFormatter.formatToParts(variables)
  });
};
var Message = /*#__PURE__*/function (_Component) {
  function Message() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Message, _Component);
  var _proto = Message.prototype;
  _proto.render = function render() {
    if (process.env.NODE_ENV !== "production") {
      assert(typeof this.props !== "string", "Message function got a String, but expected an Object. Did you mean { id: \"" + this.props + "\"} instead?");
    }
    var _this$props = this.props,
      children = _this$props.children,
      id = _this$props.id,
      namespace = _this$props.namespace,
      variables = _this$props.variables,
      source = _this$props.source,
      otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded2);
    if (process.env.NODE_ENV !== "production") {
      // 1: There are cases where empty elements are coming as empty array []
      // children, so need to check for length as well. At present we did not
      // identify the cause, it could be related to react version or due to preact.
      // Not able to reproduce this in unit tests ¯\_(ツ)_/¯
      assert(!children || !children.length /* 1 */, "Message must be an empty element (no children)");
      assertType(id, "id", ["array", "string"]);
      if (namespace) {
        assertType(namespace, "namespace", ["array", "string"]);
      }
    }
    var worldReady = this.context;
    if (process.env.NODE_ENV !== "production") {
      assert(isWorldReadyInstance(worldReady), "Missing worldReady object. Please read " + DOCUMENTATION_HOMEPAGE + "/about-get-started.html#reactjs");
    }
    var messageFmt = new MessageFormat(worldReady, {
      id: id,
      source: source,
      namespace: namespace
    });

    // If message is instance of ContentMessage:
    var _variables = variables || otherProps;

    // TODO cache formatted message, see react-globalize for reference.
    return /*#__PURE__*/React.createElement(_MessageParts, {
      messageParts: messageFmt.formatToParts(_variables)
    });
  };
  return Message;
}(Component);
_defineProperty(Message, "contextType", Context);
function getDisplayName(Component) {
  return Component.displayName || Component.name || "Component";
}
function injectWorldReady(WrappedComponent) {
  var InjectWorldReady = /*#__PURE__*/function (_Component2) {
    function InjectWorldReady() {
      return _Component2.apply(this, arguments) || this;
    }
    _inheritsLoose(InjectWorldReady, _Component2);
    var _proto2 = InjectWorldReady.prototype;
    _proto2.render = function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement(ContextConsumer, null, function (worldReady) {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, _this.props, {
          worldReady: worldReady,
          griffin: worldReady
        }));
      });
    };
    return InjectWorldReady;
  }(Component); // Why this? https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  // Why this? https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
  _defineProperty(InjectWorldReady, "displayName", "InjectWorldReady(" + getDisplayName(WrappedComponent) + ")");
  _defineProperty(InjectWorldReady, "WrappedComponent", WrappedComponent);
  hoistNonReactStatic(InjectWorldReady, WrappedComponent);
  return InjectWorldReady;
}
var injectGriffin = injectWorldReady;

export { Context, ContextConsumer, ContextProvider, Message, MessageReactWrapper, injectGriffin, injectWorldReady };
